module.exports = __webpack_public_path__ + "static/media/11.523f62d6.jpeg";